module.exports = __webpack_public_path__ + "img/login-qiye-img2.8a9fcff5.png";